// extracted by mini-css-extract-plugin
export var container = "_5z-0";
export var fallback = "_5z-5";
export var fallbackIcon = "_5z-6";
export var hidden = "_5z-2";
export var image = "_5z-3";
export var loaded = "_5z-4";
export var placeholder = "_5z-1";